export default __webpack_public_path__ + "static/media/EX-010.4c189eca.png";